module.exports = __webpack_public_path__ + "media/img/avatar-profile-01-635c7080.jpg";